export const locale = {
    lang: 'pl',
    data: {
        'Date is required!': 'Dzień jest wymagany!',
        'Hour is required!': 'Godzina jest wymagana!',
        'Minute is required!': 'Minuta jest wymagana!',
        'Name is required!': 'Nazwa jest wymagana!',
        'Service is required!': 'Usługa jest wymagana!',
        'Customer is required!': 'Klient jest wymagany!',
        'Worker is required!': 'Pracownik jest wymagany!',
        'Description': 'Opis',
        'Reservation details': 'Dane rezerwacji',
        'DELETE': 'Usuń',
        'EDIT': 'Edycja',
        'SAVE': 'Zapisz',
        'Cancel': 'Anuluj',
        'CANCEL': 'Anuluj',
        'Confirm': 'Potwierdź',
        'Are you sure you want to left current window?': 'Czy na pewno chcesz opuścić bieżące okno?',
        'Confirm deletion': 'Potwierdź usunięcie',
        'Are you sure you want to delete selected service?': 'Czy na pewno chcesz usunąć wybraną usługę?',
        'Resource': 'Zasób'
    }
};
